export const FETCH_STATUSES = 'FETCH_STATUSES';
export const FETCH_STATUSES_SUCCESS = 'FETCH_STATUSES_SUCCESS';
export const FETCH_STATUSES_ERROR = 'FETCH_STATUSES_ERROR';
